import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { PwaHandshakeService } from '../pwa-handshake.service';

@Component({
  selector: 'app-insufficient-funds',
  standalone: true,
  imports: [CommonModule,ButtonModule],
  templateUrl: './matching-error.component.html',
  styleUrl: './matching-error.component.css'
})
export class MatchingErrorComponent {
  constructor(private router:Router,
    private pwaHandshakeService:PwaHandshakeService
  ) {}
  retry() {
    this.router.navigate(['/unavailable']);
    console.log('Retry clicked');
  }

  done() {
    this.pwaHandshakeService.done();
  }
}
